<template>
    <div class="automation-wizard-form-field">
        <!-- Select field -->
        <AutomationWizardFieldSelect
            v-if="field.type === 'select'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />

        <!-- Pipeline step opportunity field -->
        <AutomationWizardFieldPipelineStepOpp
            v-else-if="field.type === 'pipeline_step_opp'"
            :field="field"
            :value="value"
            :formData="formData"
            @update:value="handleUpdateValue"
        />

        <!-- Text or textarea field -->
        <AutomationWizardFieldText
            v-else-if="field.type === 'text' || field.type === 'textarea'"
            :field="field"
            :value="value"
            :formData="formData"
            :type="field.type"
            @update:value="handleUpdateValue"
        />

        <!-- Date field (days only) -->
        <AutomationWizardFieldDate
            v-else-if="field.type === 'date'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />

        <!-- Time field (hours only) -->
        <AutomationWizardFieldTime
            v-else-if="field.type === 'time'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />

        <!-- Date time field (combined) -->
        <AutomationWizardFieldDateTime
            v-else-if="field.type === 'date_time'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />

        <!-- Priority button-->
        <AutomationWizardFieldPriority
            v-else-if="field.type === 'priority_task'"
            :field="field"
            :value="value"
            :formData="formData"
            @update:value="handleUpdateValue"
        />

        <!-- Amount field -->
        <AutomationWizardFieldAmount
            v-else-if="field.type === 'amount'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />
    </div>
</template>

<script>
import AutomationWizardFieldSelect from './Fields/AutomationWizardFieldSelect.vue';
import AutomationWizardFieldPipelineStepOpp from './Fields/AutomationWizardFieldPipelineStepOpp.vue';
import AutomationWizardFieldText from './Fields/AutomationWizardFieldText.vue';
import AutomationWizardFieldDate from './Fields/AutomationWizardFieldDate.vue';
import AutomationWizardFieldTime from './Fields/AutomationWizardFieldTime.vue';
import AutomationWizardFieldDateTime from './Fields/AutomationWizardFieldDateTime.vue';
import AutomationWizardFieldPriority from './Fields/AutomationWizardFieldPriorityIconButton.vue';
import AutomationWizardFieldAmount from './Fields/AutomationWizardFieldAmount.vue';

export default {
    name: 'AutomationWizardFormField',
    components: {
        AutomationWizardFieldSelect,
        AutomationWizardFieldPipelineStepOpp,
        AutomationWizardFieldText,
        AutomationWizardFieldDate,
        AutomationWizardFieldTime,
        AutomationWizardFieldDateTime,
        AutomationWizardFieldPriority,
        AutomationWizardFieldAmount,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Object, Boolean, Array],
            default: '',
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['update:value'],
    methods: {
        handleUpdateValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
